'use strict';

/**
 * Endpoints don't *really* have states as their states are ultimately derived from their child devices but
 * as of this writing endpoint state is a concept used in multiple places so it might as well be in a shared
 * resource even if what it represents is derived.
 */
module.exports = {
  NOT_ACTIVATED: 'NOT_ACTIVATED',
  NOT_SETUP: 'NOT_SETUP',
  READY: 'READY',
  ERROR: 'ERROR'
};